import { render, staticRenderFns } from "./FaultReportView.vue?vue&type=template&id=1ef36a6a"
import script from "./FaultReportView.vue?vue&type=script&lang=js"
export * from "./FaultReportView.vue?vue&type=script&lang=js"
import style0 from "./FaultReportView.vue?vue&type=style&index=0&id=1ef36a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports